import { COLUMN_WIDTH, ROW_HEIGHT } from "@lhd/features/Apps/AppForm/constants";
import { AppPartType } from "@lhd/features/Apps/AppForm/types";

interface IProps {
  item: AppPartType;
}

const HorizontalBorder = (props: IProps) => {
  const { item } = props;
  const { w, h, x, y } = item.item_config_data;
  const level_border = item.item_config_data?.level_horizontal || 0;
  const width = w * COLUMN_WIDTH;
  const height = h * ROW_HEIGHT;
  const height_border = COLUMN_WIDTH * level_border || 1;
  return (
    <div
      style={{
        display: "flex",
        height,
        width,
        alignItems: "center",
      }}
    >
      <div
        style={{
          background: "black",
          width: "100%",
          height: height_border,
        }}
      ></div>
    </div>
  );
};
export default HorizontalBorder;
